@if (HasRequiredPermissions) {
@if (EntityInstance || isNew()) {
<!-- Conteneur principal avec layout flexbox -->
<div [fieldContext]="this" class="flex flex-col h-full">
  <!-- Titre fixe en dehors de la zone de défilement -->
  <div class="px-6 pt-4 pb-2">
    <h4 class="text-[0.9em] font-medium text-gray-500 z-[999]">
      @if (isNew()) {
      {{ 'entities.account.newEntity' | translate }}
      } @else {
      {{ 'entities.account.detailEntity' | translate }}
      }
    </h4>
    <div class="flex justify-between items-center">
      <button (click)="cancelEdit()" class="absolute top-2 right-2 text-gray-500 hover:text-gray-700 transition-colors">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
  </div>
  <!-- Zone de contenu avec défilement -->
  <div #scrollContainer class="{{Skin.detailContainer}} flex-1 overflow-auto">
    <!--  Conteneur desactivable -->
    <div class="{{this.UpdateMode}}">
      <!-- Informations du rôle -->
      <div class="mt-4">
        <h3 class="{{Skin.formSectionSmallTitle}}">
          <i class="fa-solid fa-user"></i> {{
          'vues.role.detail.sections.role-info' | translate
          }}
        </h3>
        <div class="space-y-2">
          <!-- Name -->
          <app-field-wrapper property="name">
            <input type="text" autocomplete="off" onReady (autoBind)="bindingHandler($event, 'name')"
              class="{{Skin.formInputSmallSize}}" [class.border-red-500]="hasValidationErrors('name')">
          </app-field-wrapper>
          <app-field-wrapper property="email">
            <input type="email" autocomplete="off" onReady [readonly]="!isNew()" (autoBind)="bindingHandler($event, 'email')"
              class="{{Skin.formInputSmallSize}}" [class.border-red-500]="hasValidationErrors('email')">
          </app-field-wrapper>
          <app-field-wrapper property="phoneNumber">
            <input type="tel" autocomplete="off" onReady (autoBind)="bindingHandler($event, 'phoneNumber')"
              class="{{Skin.formInputSmallSize}}" [class.border-red-500]="hasValidationErrors('phoneNumber')">
          </app-field-wrapper>
          <app-field-wrapper property="password">
            <input type="password" autocomplete="off" onReady (autoBind)="bindingHandler($event, 'password')"
              class="{{Skin.formInputSmallSize}}" [class.border-red-500]="hasValidationErrors('password')">
          </app-field-wrapper>
          <app-field-wrapper property="confirmPassword">
            <input type="password" autocomplete="off" onReady (autoBind)="bindingHandler($event, 'confirmPassword')"
              class="{{Skin.formInputSmallSize}}" [class.border-red-500]="hasValidationErrors('confirmPassword')">
          </app-field-wrapper>
          <app-field-wrapper property="fK_i18nLanguage" label="entities.account.propreties.language">
            <select class="{{Skin.formInputSmallSize}}" required onReady (autoBind)="bindingHandler($event, 'fK_i18nLanguage')"
              [class.border-red-500]="hasValidationErrors('fK_i18nLanguage')">
              <option [value]="null" disabled>{{ 'Choose a language' | translate }}</option>
              @for (languageOption of languageLookup(); track languageOption.key) {
              <option [value]="languageOption.key">{{ `languages.${languageOption.value}` | translate }}</option>
              }
            </select>
          </app-field-wrapper>
        </div>
      </div>
      <div class="mt-10">
        <h3 class="{{Skin.formSectionSmallTitle}}">
          <i class="fas fa-lock"></i> {{
          'vues.account.detail.sections.permissions' | translate
          }}
        </h3>
        <div class="space-y-2">
          <app-field-wrapper property="fK_Role" label="entities.account.propreties.role">
            <select class="{{Skin.formInputSmallSize}}" required onReady (autoBind)="bindingHandler($event, 'fK_Role')"
              (change)="onRoleChange($event)" [class.border-red-500]="hasValidationErrors('fK_Role')">
              <option [value]="null" disabled>{{ 'Choose a role' | translate }}</option> <!-- Placeholder -->
              @for (roleOption of roleLookup(); track roleOption.key) {
              <option [value]="roleOption.key">{{ roleOption.value }}</option>
              }
            </select>
          </app-field-wrapper>
          <!-- Champ twoFactorEnabled (checkbox) -->
          <app-field-wrapper property="twoFactorEnabled">
            <input class="w-5 h-5 mr-2 cursor-pointer" type="checkbox" onReady
              (autoBind)="bindingHandler($event, 'twoFactorEnabled')">
          </app-field-wrapper>
          <!-- Champ isDisabled (checkbox) : bloque la connexion côté Auth.Server -->
          <app-field-wrapper property="isDisabled">
            <input class="w-5 h-5 mr-2 cursor-pointer" type="checkbox" onReady
              (autoBind)="bindingHandler($event, 'isDisabled')">
          </app-field-wrapper>
        </div>
      </div>
    </div>
  </div>
  <!-- Bandeau pour le nombre d'erreurs -->
  @if (generalErrorCount() > 0) {
  <div
    class="mb-1 p-1 bg-orange-100 text-red-700 border border-orange-300 rounded-full text-xs sticky bottom-14 z-10 py-1 -mt-1 z-20 text-center">
    <i class="fas fa-exclamation-triangle mr-1 ml-2"></i>
    {{ generalErrorCount() }} erreur(s) dans le formulaire
  </div>
  }
  <!-- Boutons en bas du formulaire - TOUJOURS VISIBLES -->
  <div
    class="bg-stone-50 min-w-full flex space-x-1 justify-center pt-2 border-t border-gray-200">
    <button type="button" (click)="saveItem()" [disabled]="!isFormValid()" data-testid="detail-save"
      class="{{Skin.btnPrimary}} uppercase py-2 px-2">
      <i class="far fa-check-square mr-2"></i>
      {{ 'buttons.save' | translate }}
    </button>
    <button type="button" (click)="saveAndCloseItem()" [disabled]="!isFormValid()" data-testid="detail-save-close"
      class="{{Skin.btnPrimary}} uppercase py-2 px-2">
      <i class="far fa-check-square mr-2"></i>
      {{ 'buttons.save-and-close' | translate }}
    </button>
    <button (click)="cancelEdit()" class="{{Skin.btnAlert}} uppercase py-2 px-2">
      <i class="fas fa-times mr-2"></i>
      {{ 'buttons.cancel' | translate }}
    </button>
  </div>
</div>
}
}